import { render, staticRenderFns } from "./SvgPie.vue?vue&type=template&id=49c43065&scoped=true"
import script from "./SvgPie.vue?vue&type=script&lang=js"
export * from "./SvgPie.vue?vue&type=script&lang=js"
import style0 from "./SvgPie.vue?vue&type=style&index=0&id=49c43065&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c43065",
  null
  
)

export default component.exports